/* tslint:disable */
/* eslint-disable */
/**
 * crm-phone-agent
 * crm-phone-agent
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CallExecutionRecord } from './CallExecutionRecord';
import {
    CallExecutionRecordFromJSON,
    CallExecutionRecordFromJSONTyped,
    CallExecutionRecordToJSON,
    CallExecutionRecordToJSONTyped,
} from './CallExecutionRecord';

/**
 * 
 * @export
 * @interface FindCallExecutionById200Response
 */
export interface FindCallExecutionById200Response {
    /**
     * 
     */
    data?: CallExecutionRecord;
}

/**
 * Check if a given object implements the FindCallExecutionById200Response interface.
 */
export function instanceOfFindCallExecutionById200Response(value: object): value is FindCallExecutionById200Response {
    return true;
}

export function FindCallExecutionById200ResponseFromJSON(json: any): FindCallExecutionById200Response {
    return FindCallExecutionById200ResponseFromJSONTyped(json, false);
}

export function FindCallExecutionById200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): FindCallExecutionById200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : CallExecutionRecordFromJSON(json['data']),
    };
}

export function FindCallExecutionById200ResponseToJSON(json: any): FindCallExecutionById200Response {
    return FindCallExecutionById200ResponseToJSONTyped(json, false);
}

export function FindCallExecutionById200ResponseToJSONTyped(value?: FindCallExecutionById200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': CallExecutionRecordToJSON(value['data']),
    };
}

